<template>
  <section id="patientRegistration" class="patient-recruitment-section">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">患者报名</h2>
        <div class="title-underline"></div>
        <p class="section-description">
          如果您或您认识的人正在寻找新的治疗方案，
          欢迎报名参加我们的临床研究项目，获取前沿治疗机会。
        </p>
      </div>
      
      <div class="form-container">
        <div 
          class="form-card"
          v-motion
          :initial="{ opacity: 0, y: 50 }"
          :visible="{ opacity: 1, y: 0 }"
          :transition="{ duration: 0.8 }"
        >
          <h3 class="form-title">患者报名免费用药申请表</h3>
          
          <form @submit.prevent="handleSubmit" class="recruitment-form">
            <div class="form-grid">
              <div class="form-field">
                <label for="userName" class="field-label">姓名 <span class="required">*</span></label>
                <input
                  type="text"
                  id="userName"
                  name="userName"
                  v-model="formData.userName"
                  required
                  class="field-input"
                  placeholder="请输入您的姓名"
                />
              </div>
              
<div class="form-field">
  <label for="phoneNum" class="field-label">手机号码 <span class="required">*</span></label>
  <input
    type="tel"
    id="phoneNum"
    name="phoneNum"
    v-model="formData.phoneNum"
    required
    class="field-input"
    :class="{ 'invalid': formData.phoneNum && !validatePhone(formData.phoneNum) }"
    placeholder="请输入您的手机号码"
    @blur="validatePhone(formData.phoneNum)"
  />
  <div 
    v-if="formData.phoneNum && !validatePhone(formData.phoneNum)" 
    class="error-message"
  >
    请输入正确的手机号码
  </div>
</div>
              
              <div class="form-field">
                <label for="email" class="field-label">电子邮箱</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  v-model="formData.email"
                  class="field-input"
                  placeholder="请输入您的电子邮箱"
                />
              </div>
              
              <div class="form-field">
                <label for="age" class="field-label">年龄 <span class="required">*</span></label>
                <input
                  type="number"
                  id="age"
                  name="age"
                  v-model="formData.age"
                  required
                  class="field-input"
                  placeholder="请输入您的年龄"
                />
              </div>
              
              <div class="form-field">
                <label for="gender" class="field-label">性别 <span class="required">*</span></label>
                <select
                  id="gender"
                  name="gender" 
                  v-model="formData.gender"
                  required
                  class="field-input"
                >
                  <option value="">请选择</option>
                  <option value="男">男</option>
                  <option value="女">女</option>
                  <option value="other">其他</option>
                </select>
              </div>
              
              <div class="form-field">
                <label for="diseaseType" class="field-label">主要病症 <span class="required">*</span></label>
                <input
                  type="text"
                  id="diseaseType"
                  name="diseaseType"
                  v-model="formData.diseaseType"
                  required
                  class="field-input"
                  placeholder="请输入您的主要病症"
                />
              </div>
            </div>
            
            <div class="form-field">
              <label for="hasMedicalHistory" class="field-label">是否有其他病史？</label>
              <select
                id="hasMedicalHistory"
                name="hasMedicalHistory"
                v-model="formData.hasMedicalHistory"
                class="field-input"
              >
                <option value="">请选择</option>
                <option value="yes">是</option>
                <option value="no">否</option>
              </select>
            </div>
            
            <div v-if="formData.hasMedicalHistory === 'yes'" class="form-field">
              <label for="medicalHistory" class="field-label">病史描述</label>
              <textarea
                id="medicalHistory"
                name="medicalHistory"
                v-model="formData.medicalHistory"
                rows="4"
                class="field-input field-textarea"
                placeholder="请详细描述您的病史情况"
              ></textarea>
            </div>
            
            <div class="consent-section">
              <label class="consent-label">
                <input
                  type="checkbox"
                  name="consent"
                  v-model="formData.consent"
                  class="consent-checkbox"
                />
                <span class="consent-text">
                  我已阅读并同意<a href="#" class="consent-link">《隐私政策》</a>和<a href="#" class="consent-link">《知情同意书》</a>，
                  同意贵公司收集和使用我的个人信息用于临床研究招募目的。 <span class="required">*</span>
                </span>
              </label>
            </div>
            
            <div class="submit-section">
              <button
                type="submit"
                :disabled="isSubmitting"
                class="submit-button"
              >
                <span v-if="isSubmitting" class="submitting-text">
                  <i class="spinner-icon"></i>
                  提交中...
                </span>
                <span v-else class="submit-text">提交报名</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, reactive } from 'vue'

const isSubmitting = ref(false)

const formData = reactive({
  userName: '',
  phoneNum: '',
  email: '',
  age: '',
  gender: '',
  diseaseType: '',
  hasMedicalHistory: '',
  medicalHistory: '',
  consent: false
})

// 手机号校验正则表达式
const validatePhone = (phone) => {
  const phoneRegex = /^1[3-9]\d{9}$/
  return phoneRegex.test(phone)
}
const handleSubmit =async  (e) => {
  e.preventDefault()
  
  if (!formData.consent) {
    // 使用浏览器原生 alert 替代 toast
    alert('请同意隐私政策和知情同意书')
    return
  }
  
  isSubmitting.value = true
  
   try {
    const response = await fetch('https://jidujiankang.com/wx/netApply', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userName: formData.userName,
        phoneNum: formData.phoneNum,
        email: formData.email,
        age: parseInt(formData.age),
        gender: formData.gender,
        diseaseType: formData.diseaseType,
        hasMedicalHistory: formData.hasMedicalHistory,
        medicalHistory: formData.hasMedicalHistory === 'yes' ? formData.medicalHistory : ''
      })
    })
    
    if (response.ok) {
      alert('报名成功！我们的医疗顾问将尽快与您联系。')
      Object.assign(formData, {
        userName: '',
        phoneNum: '',
        email: '',
        age: '',
        gender: '',
        diseaseType: '',
        hasMedicalHistory: '',
        medicalHistory: '',
        consent: false
      })
    } else {
      alert('提交失败，请稍后重试')
    }
  } catch (error) {
    console.error('提交错误:', error)
    alert('网络错误，请检查连接后重试')
  } finally {
    isSubmitting.value = false
  }
}
</script>

<style scoped>
.field-input.invalid {
  border-color: #dc2626;
}

.error-message {
  color: #dc2626;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
.patient-recruitment-section {
  padding: 3rem 0; /* 减少移动端的上下内边距 */
  background-color: #f9fafb;
}

.container {
  width: 100%;
  margin: 0 auto;
  padding: 0 1rem;
  box-sizing: border-box; /* 确保padding不会增加总宽度 */
}

@media (min-width: 640px) {
  .container {
    padding: 0 1.5rem;
  }
}

@media (min-width: 1024px) {
  .container {
    max-width: 1280px;
    padding: 0 2rem;
  }
}

.section-header {
  text-align: center;
  margin-bottom: 2rem; /* 减少移动端的底部间距 */
  padding: 0 0.5rem; /* 增加小屏幕的左右内边距 */
}

.section-title {
  font-size: 1.5rem; /* 减小移动端标题大小 */
  font-weight: 700;
  color: #111827;
  margin-bottom: 1rem;
  line-height: 1.2; /* 优化行高 */
}

@media (min-width: 640px) {
  .section-title {
    font-size: 1.875rem;
  }
}

@media (min-width: 768px) {
  .section-title {
    font-size: 2.25rem;
  }
}

.title-underline {
  width: 4rem; /* 减小下划线长度 */
  height: 0.25rem;
  background-color: #2563eb;
  margin: 0 auto 1rem; /* 增加下划线与描述的间距 */
  border-radius: 9999px;
}

.section-description {
  color: #4b5563;
  max-width: 42rem;
  margin-left: auto;
  margin-right: auto;
  font-size: 1rem; /* 减小移动端描述文字大小 */
  line-height: 1.6; /* 优化行高 */
}

.form-container {
  max-width: 896px;
  margin: 0 auto;
  width: 100%; /* 确保在小屏幕上占满宽度 */
  padding: 0 0.5rem;
  box-sizing: border-box;
}

.form-card {
  background-color: white;
  border-radius: 1rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  padding: 1.5rem; /* 减小移动端内边距 */
  width: 100%;
  box-sizing: border-box;
}

@media (min-width: 768px) {
  .form-card {
    padding: 2.5rem;
  }
}

.form-title {
  font-size: 1.25rem; /* 减小移动端标题 */
  font-weight: 700;
  color: #111827;
  margin-bottom: 1.5rem;
  text-align: center;
}

@media (min-width: 640px) {
  .form-title {
    font-size: 1.5rem;
  }
}

.recruitment-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem; /* 减小移动端表单元素间距 */
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr; /* 移动端单列布局 */
  gap: 1.25rem;
}

/* 平板及以上设备使用双列布局 */
@media (min-width: 640px) {
  .form-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
}

.form-field {
  display: flex;
  flex-direction: column;
}

.field-label {
  display: block;
  color: #374151;
  font-weight: 500;
  margin-bottom: 0.5rem;
  font-size: 0.9rem; /* 适配移动端字体 */
}

.field-input {
  width: 100%;
  padding: 0.85rem 1rem; /* 增加输入框高度，便于触摸操作 */
  border-radius: 0.5rem;
  border: 1px solid #d1d5db;
  transition: all 0.2s ease;
  min-height: 48px; /* 确保足够的触摸区域 */
  font-family: inherit;
  font-size: 1rem;
  color: #374151;
  box-sizing: border-box;
}

/* 确保在小屏幕上输入框有足够的触摸区域 */
@media (max-width: 480px) {
  .field-input {
    min-height: 52px;
  }
}

.field-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.5);
}

.field-input::-webkit-input-placeholder {
  color: #9ca3af;
}

.field-input::-moz-placeholder {
  color: #9ca3af;
}

.field-input:-ms-input-placeholder {
  color: #9ca3af;
}

.field-input::-ms-input-placeholder {
  color: #9ca3af;
}

.field-input::placeholder {
  color: #9ca3af;
}

.field-textarea {
  min-height: 100px;
  resize: vertical;
}

/* 特别针对select元素 */
select.field-input {
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e");
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
}

.consent-section {
  padding-top: 0.5rem;
}

.consent-label {
  display: flex;
  align-items: flex-start;
}

.consent-checkbox {
  margin-top: 0.25rem;
  margin-right: 0.75rem;
  height: 1.25rem;
  width: 1.25rem;
  color: #2563eb;
  border-color: #d1d5db;
  border-radius: 0.25rem;
  accent-color: #2563eb;
  /* 增加触摸区域 */
  transform: scale(1.1);
}

.consent-text {
  color: #374151;
  font-size: 0.85rem; /* 适配移动端字体 */
  line-height: 1.4; /* 优化行高，便于阅读 */
}

/* 小屏幕优化同意条款文字 */
@media (max-width: 480px) {
  .consent-text {
    font-size: 0.8rem;
  }
}

.consent-link {
  color: #2563eb;
  text-decoration: none;
}

.consent-link:hover {
  text-decoration: underline;
}

.submit-section {
  text-align: center;
  padding-top: 1rem;
}

.submit-button {
  background-color: #2563eb;
  color: white;
  font-weight: 700;
  padding: 0.9rem 2.5rem; /* 增大按钮，便于触摸 */
  border-radius: 9999px;
  transition: all 0.3s ease;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%; /* 移动端按钮占满宽度 */
  max-width: 300px; /* 限制最大宽度 */
  font-size: 1.05rem;
}

/* 平板及以上设备按钮不占满宽度 */
@media (min-width: 640px) {
  .submit-button {
    width: auto;
  }
}

.submit-button:hover:not(:disabled) {
  background-color: #1d4ed8;
  transform: scale(1.05);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.submit-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.5), 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.submitting-text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner-icon::before {
  content: "\f110";
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  margin-right: 0.5rem;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.required {
  color: #dc2626;
}
</style>
    